import { render, staticRenderFns } from "./UserApi.vue?vue&type=template&id=83c773ae&"
import script from "./UserApi.vue?vue&type=script&lang=js&"
export * from "./UserApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports